import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import { colorsNew } from 'root/src/client/web/commonStyles'

const style = {
	line: {
		width: '100%',
		height: 2,
		backgroundColor: colorsNew.dark2,
	},
	commentForm: {
		maxWidth: 840,
		margin: [[10, 16]],
	},
}

const HorizontalLine = ({ children, classes, width, marginTop, commentForm }) => (
	<div
		className={classNames(classes.line, {
			[classes.commentForm]: commentForm,
		})}
		style={{ maxWidth: width, marginTop }}
	>
		{children}
	</div>
)

export default withStyles(style, { name: 'MuiHorizontalLine' })(HorizontalLine)
